import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PageHeader = ({ title, subtitle, action }) => {
    const theme = useTheme();

    return (
        <Box 
            className="animate-fade-in"
            sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                mb: 6, 
                pb: 3, 
                borderBottom: `1px solid ${theme.palette.divider}`
            }}
        >
            <Box>
                <Typography 
                    variant="h4" 
                    sx={{ 
                        fontWeight: 800,
                        background: 'linear-gradient(135deg, #22D3EE 0%, #6366F1 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        display: 'inline-block',
                        letterSpacing: '-0.02em',
                    }}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            mt: 1, 
                            color: 'text.secondary',
                            fontWeight: 500,
                            maxWidth: '600px',
                            opacity: 0.8
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
            
            {action && (
                <Box sx={{ display: 'flex', gap: 2 }}>
                    {action}
                </Box>
            )}
        </Box>
    );
};

export default PageHeader;
